import React, { Component } from 'react'
import { Checkbox, FormControlLabel, Typography, TextField, Tooltip, Slider, Grid, Box } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  markLabel: {
    color: 'white',
  },
  markLabelChecked: {
    color: 'grey',
  },
  slider: {
    color: 'primary',
  },
  sliderChecked: {
    color: 'grey',
  },
};

class SingleSlider extends Component {
  state = {
    val_min: this.props.range[0],
    val_max: this.props.range[1],
    value: this.props.range[0],
    checkboxChecked: true,
  };

  handleUpdate = (event, newValue) => {
    this.setState({ value: newValue , checkboxChecked: false});
    this.props.onChangeSlider(this.props.id, newValue);
    console.log("SingleSlider: handleUpdate: ", newValue);
  };

  handleCheckbox = (event) => {
    this.setState({ checkboxChecked: event.target.checked });
    this.props.onChangeCheckbox(this.props.id, event.target.checked);
    console.log("SingleSlider: handleCheckbox: ", event.target.checked);
  }

  render() {
    const { val_min, val_max, checkboxChecked } = this.state;
    const { classes } = this.props;

    const marks = val_max < 25 
    ? Array.from({ length: val_max - val_min + 1 }, (_, i) => ({
        value: i + val_min,
        label: `${i + val_min}`,
    }))
    : Array.from({ length: Math.floor((val_max - val_min) / 10) + 2 }, (_, i) => ({
      value: i === 0 ? 0 : i * 10 - 1,
      label: `${i === 0 ? 0 : i * 10 - 1}`,
  }));

    const markLabelStyle = checkboxChecked ? classes.markLabelChecked : classes.markLabel;
    const sliderStyle = checkboxChecked ? classes.sliderChecked : classes.slider;


    return (
      <Grid container>
        <Grid item xs={12} style={{ marginLeft: '6px' }}>
            <Slider
                aria-label="Instance"
                defaultValue={val_min}
                valueLabelDisplay="auto"
                shiftStep={1}
                step={1}
                marks={marks}
                classes={{
                  markLabel: markLabelStyle,
                  root: sliderStyle,
                }}
                min={val_min}
                max={val_max}           
                onChange={this.handleUpdate}
              />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
            control={
              <Checkbox
                checked={checkboxChecked}
                onChange={this.handleCheckbox}
                name="checkbox"
                // color="primary"
                style={{ color: 'white' }}
              />
            }
            label="show all"
          />
        </Grid> 
      </Grid>
    
    );
  }
}

export default withStyles(styles)(SingleSlider);